/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Common address entity that used almost everywhere in Ingrid's API. */
export interface Address {
  /** List of address lines part of address such as street and building number */
  address_lines?: string[];
  /** Number of the apartment. */
  apartment_number?: string;
  /**
   * Attention field. Can be used to indicate an employee if the address is a
   * company address [optional]
   */
  attn?: string;
  /** in the UK some buildings do not have a number, only a name */
  building_name?: string;
  /** Care of part of address usually written as `c/o` [optional] */
  care_of?: string;
  /** Name of the city */
  city?: string;
  /**
   * Geolocation coordinates of the address. If reverse geolocation lookup of the
   * address was successful this property will be populated. If coordinates are
   * available they will be used to in service point search. In case of
   * `search_address` coordinates can also be set by merchant if known.
   */
  coordinates?: Coordinates;
  /**
   * Country should be specified as two uppercase letters (ISO Alpha-2).
   * Example `SE` for Sweden, `ES` for Spain.
   */
  country?: string;
  /** The door code to the main entrance of the building if applicable [optional] */
  door_code?: string;
  /** Floor number [optional] */
  floor_number?: string;
  /** Customer or company name */
  name?: string;
  /** ID of the PO Box [optional] */
  po_box_id?: string;
  /** Postal code (or zipcode in US) */
  postal_code?: string;
  /** Region can be a state or a province [optional] */
  region?: string;
  /** Name of the street. */
  street?: string;
  /** Number of the street. */
  street_number?: string;
  /**
   * Further division of regions. Example countries are GB, IE, IT, LT, MX
   * For example for The Republic Of Ireland there are 4 provinces (regions),
   * e.g. `Connacht` and 26 counties (subregions), e.g. `Galway`
   * Format is ISO 3166 where applicable, exceptions are e.g. Mexico [optional]
   */
  subregion?: string;
}

export interface Any {
  "@type"?: string;
  [key: string]: any;
}

/** Asset is a representation of a file that is stored in the service-tracking-assets`. */
export interface Asset {
  /** The ID of the asset. Can be used to retrieve the asset file from the service-tracking-assets`. */
  id?: string;
  /** The URL of the asset. Needs to be authenticated to access the asset file. */
  url?: string;
}

/** Cart represents the contents of a shopping cart. */
export interface Cart {
  /** Attributes represents a list of custom string values that can be associated with the cart. */
  attributes?: string[];
  /**
   * Currency is represented as a symbol (ISO-4217 - 3 letters string).
   * Examples: USD, PLN, SEK.
   */
  currency?: string;
  /**
   * GrandTotal is the final amount the customer is required to pay.
   * @format int32
   */
  grand_total?: number;
  /** Items represents the items included in the cart. */
  items?: Item[];
  /**
   * OrderDiscount is a static value of the discount for the cart in cents.
   * Example: `2000` represents `20.00`.
   * @format int32
   */
  order_discount?: number;
  /**
   * ShippingPrice is the price for shipping in cents.
   * Example: `2000` represents `20.00`.
   * @format int32
   */
  shipping_price?: number;
  /**
   * Subtotal is the sum of prices of all items before adding additional charges (tax, shipping fees etc.).
   * @format int32
   */
  subtotal?: number;
  /**
   * Tax is the tax amount for the cart in cents.
   * Example: `2000` represents `20.00`.
   * @format int32
   */
  tax?: number;
  /**
   * Total is the total cart value in cents after applying discounts.
   * Example: `20000` represents `200.00`.
   * @format int32
   */
  total?: number;
  /**
   * TotalDiscount is the total discount amount (cart and order) for the cart in cents.
   * Example: `2000` represents `20.00`.
   * @format int32
   */
  total_discount?: number;
}

/**
 * CentraDeliveryGroupCancelled is used in SplitShipment scenarios to
 * indicate that delivery group has been cancelled in centra.
 */
export interface CentraDeliveryGroupCancelled {
  tos_id?: string;
}

export interface CentraOrderConfirmed {
  order?: CentraOrderConfirmedOrder;
}

export interface CentraOrderConfirmedDeliveryGroup {
  items?: Item[];
  /**
   * Specifies the actual tos_id the item belongs to. This is relevant for Centra orders with multiple delivery groups,
   * where each delivery group corresponds to a separate TOS Order.
   * In such cases, `CentraOrderConfirmed.Cart` contains the full cart, including all delivery groups.
   */
  tos_id?: string;
}

export interface CentraOrderConfirmedItem {
  image_url?: string;
  sku?: string;
}

export interface CentraOrderConfirmedOrder {
  attributes?: object;
  /** Cart represents the contents of a shopping cart. */
  cart?: Cart;
  delivery_groups?: CentraOrderConfirmedDeliveryGroup[];
  /**
   * Excepted number of shipments. Can be used in combination with `IsSplitShipment` to manage customer communication.
   * @format int64
   */
  expected_shipments_count?: string;
  /**
   * This field carries locale that is only used for H&M.
   * Do not use it for anything else.
   * We need this field because H&M uses locales that we do not support.
   */
  hm_locale?: string;
  /**
   * Defines whether the order is supposed to have multiple shipments from different warehouses.
   * Eventually we don't know how many shipments will be created.
   * Might happen that the order marked as `split_shipment`
   * will end up with only one shipment created (from single warehouse) due to items cancellation, etc.
   */
  is_split_shipment?: boolean;
  items?: CentraOrderConfirmedItem[];
  payment_method?: string;
  payments?: CentraOrderConfirmedPayment[];
  /** deprecated: qr_code on Order attributes instead. */
  qr_code?: string;
}

export interface CentraOrderConfirmedPayment {
  /** @format int32 */
  amount?: number;
  currency?: string;
  method?: string;
  params?: CentraOrderConfirmedPaymentParams;
  /** @format date-time */
  timestamp?: string;
}

export interface CentraOrderConfirmedPaymentParams {
  obfuscated_voucher_code?: string;
}

/** Geolocation coordinates */
export interface Coordinates {
  /**
   * Latitude
   * @format double
   */
  lat?: number;
  /**
   * Longitude
   * @format double
   */
  lng?: number;
}

export type DeliveryDelayed = object;

export type DeliveryFailed = object;

/**
 * Indicates the type of the delivery
 * - UNKNOWN: Delivery type is not known for some reason
 *  - DELIVERY: Home delivery
 *  - PICKUP: Delivery to a service point or a locker
 *  - MAILBOX: Delivery to customer's mailbox
 *  - INSTORE: Delivery to one of the merchants stores
 *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
 * @default "UNKNOWN"
 */
export type DeliveryType = "UNKNOWN" | "DELIVERY" | "PICKUP" | "MAILBOX" | "INSTORE" | "INWAREHOUSE";

/**
 * Indicates intended direction of parcel, shipment etc.
 *
 *  - OUTBOUND: From merchant to customer.
 *  - RETURN: Return from customer to merchant.
 *  - UNSPECIFIED: Unspecified means we do not know the direction. It is the default state when we do not know any better.
 * @default "UNKNOWN_DIRECTION_TYPE"
 */
export type DirectionType = "UNKNOWN_DIRECTION_TYPE" | "OUTBOUND" | "RETURN" | "UNSPECIFIED";

export interface EstimatedDeliveryTimeExceeded {
  /** Earliest and/or latest time when the parcel is estimated to arrive to its destination. */
  estimated_time_of_arrival?: EstimatedTimeOfArrival;
  /**
   * Version of eta that was exceeded.
   * @format int64
   */
  eta_version?: string;
}

export interface EstimatedDeliveryTimeUpdated {
  /** Earliest and/or latest time when the parcel is estimated to arrive to its destination. */
  estimated_time_of_arrival?: EstimatedTimeOfArrival;
  /**
   * Version of eta that this exception updated to.
   * @format int64
   */
  eta_version?: string;
}

export interface EstimatedPreparationTimeExceeded {
  /** Earliest and/or latest time when the marchant is estimated to prepare the order items. */
  estimated_time_of_preparation?: EstimatedTimeOfPreparation;
  /**
   * Version of etp that was exceeded.
   * @format int64
   */
  etp_version?: string;
}

export interface EstimatedPreparationTimeUpdated {
  /** Earliest and/or latest time when the marchant is estimated to prepare the order items. */
  estimated_time_of_preparation?: EstimatedTimeOfPreparation;
  /**
   * Version of etp that this exception updated to.
   * @format int64
   */
  etp_version?: string;
}

export interface EstimatedSubmissionTimeExceeded {
  /** Earliest and/or latest time when the parcel is estimated to be submitted to carrier. */
  estimated_time_of_submission?: EstimatedTimeOfSubmission;
  /**
   * Version of ets that was exceeded.
   * @format int64
   */
  ets_version?: string;
}

export interface EstimatedSubmissionTimeUpdated {
  /** Earliest and/or latest time when the parcel is estimated to be submitted to carrier. */
  estimated_time_of_submission?: EstimatedTimeOfSubmission;
  /**
   * Version of ets that this exception updated to.
   * @format int64
   */
  ets_version?: string;
}

export interface EstimatedTimeOfArrival {
  /**
   * Earliest delivery date in RFC3339 format. No specific time of day is
   * promised if the time part is 00:00:00
   */
  earliest?: string;
  /**
   * Latest delivery date in RFC3339 format. No specific time of day is
   * promised if the time part is 00:00:00
   */
  latest?: string;
  /** Source indicates where the ETA information comes from. */
  source?: string;
  /** Date in RFC3339 format of the event providing the ETA value. */
  updated_at?: string;
  /**
   * Version of the ETA.
   * @format int64
   */
  version?: string;
}

export interface EstimatedTimeOfPreparation {
  /**
   * Earliest preparation date in RFC3339 format. No specific time of day is
   * promised if the time part is 00:00:00
   */
  earliest?: string;
  /**
   * Latest preparation date in RFC3339 format. No specific time of day is
   * promised if the time part is 00:00:00
   */
  latest?: string;
  /** Source indicates where the ETP information comes from. */
  source?: string;
  /** Date in RFC3339 format of the event providing the ETP value. */
  updated_at?: string;
  /**
   * Version of the ETP.
   * @format int64
   */
  version?: string;
}

export interface EstimatedTimeOfSubmission {
  /**
   * Earliest submission date in RFC3339 format. No specific time of day is
   * promised if the time part is 00:00:00
   */
  earliest?: string;
  /**
   * Latest submission date in RFC3339 format. No specific time of day is
   * promised if the time part is 00:00:00
   */
  latest?: string;
  /** Source indicates where the ETS information comes from. */
  source?: string;
  /** Date in RFC3339 format of the event providing the ETS value. */
  updated_at?: string;
  /**
   * Version of the ETS.
   * @format int64
   */
  version?: string;
}

export interface Exception {
  /**
   * CentraDeliveryGroupCancelled is used in SplitShipment scenarios to
   * indicate that delivery group has been cancelled in centra.
   */
  centra_delivery_group_cancelled?: CentraDeliveryGroupCancelled;
  centra_order_confirmed?: CentraOrderConfirmed;
  /** Created_at is the rfc3339 time event was registered in Ingrid system. */
  created_at?: string;
  delivery_delayed?: DeliveryDelayed;
  delivery_failed?: DeliveryFailed;
  estimated_delivery_time_exceeded?: EstimatedDeliveryTimeExceeded;
  estimated_delivery_time_updated?: EstimatedDeliveryTimeUpdated;
  estimated_preparation_time_exceeded?: EstimatedPreparationTimeExceeded;
  estimated_preparation_time_updated?: EstimatedPreparationTimeUpdated;
  estimated_submission_time_exceeded?: EstimatedSubmissionTimeExceeded;
  estimated_submission_time_updated?: EstimatedSubmissionTimeUpdated;
  /** External_source is an indicator of a type of tracking integration that is the origin of the event. */
  external_source?: ExternalSource;
  /** `service-instore` specific exceptions. */
  instore_parcel_arrived?: InstoreParcelArrived;
  /**
   * InstoreParcelSentBack is sent from the `service-instore` when the parcel is sent back to the merchant.
   * This is only sent if the parcel was not picked up by the customer.
   */
  instore_parcel_overdue?: InstoreParcelOverdue;
  /** InstoreParcelPickedUp is sent from the `service-instore` when the parcel is picked up by the customer. */
  instore_parcel_picked_up?: InstoreParcelPickedUp;
  /** InstoreParcelRefused is sent from the `service-instore` when the parcel is refused by the customer. */
  instore_parcel_refused?: InstoreParcelRefused;
  /** InstoreParcelRelocated is sent from the `service-instore` when the parcel is relocated by the store staff. */
  instore_parcel_relocated?: InstoreParcelRelocated;
  instore_parcel_returned?: InstoreParcelReturned;
  /** InstoreParcelSendAccepted is send when package is accepted in the Instore app in the Active Return scenario. */
  instore_parcel_send_accepted?: InstoreParcelSendAccepted;
  notification_delivered?: NotificationDelivered;
  notification_failed?: NotificationFailed;
  notification_triggered?: NotificationTriggerred;
  /** Occurred_at is the rfc3339 time event occured. */
  occurred_at?: string;
  order_cancelled?: OrderCancelled;
  /** deprecated in favour of `OrderCancelled` */
  order_cancelled_by_customer?: OrderCancelledByCustomer;
  /** deprecated in favour of `OrderCancelled` */
  order_cancelled_by_merchant?: OrderCancelledByMerchant;
  order_items_cancelled?: OrderItemsCancelled;
  order_receipt_available?: OrderReceiptAvailable;
  out_for_delivery?: OutForDelivery;
  payment_declined?: PaymentDeclined;
  /**
   * PickupReminderTriggered is sent when a reminder to pick up a parcel is triggered.
   * This could be used to notify the customer to pick up their parcel before a specified deadline.
   */
  pickup_reminder_triggered?: PickupReminderTriggered;
  price_adjustment_receipt_available?: PriceAdjustmentReceiptAvailable;
  /**
   * RemainingShipmentsCancelled is used in SplitShipment scenarios to
   * indicate that any shipments that have not been shipped will not be shipped at all.
   */
  remaining_shipments_cancelled?: RemainingShipmentsCancelled;
  return_created?: ReturnCreated;
  return_receipt_available?: ReturnReceiptAvailable;
  /**
   * ReturnRequested is sent when a system or service wants to initiate the return process for a return parcel.
   * This message serves as a signal to indicate that the parcel should be visible in tracking systems.
   */
  return_requested?: ReturnRequested;
  /** Site_id is the owner of the tracking event. */
  site_id?: string;
  /** Tos_id is the id of the order this event relates to. */
  tos_id?: string;
  /** Tracking_number is the tracking number assigned by a carrier. */
  tracking_number?: string;
}

/** @default "EXTERNAL_SOURCE_UNKNOWN" */
export type ExternalSource =
  | "EXTERNAL_SOURCE_UNKNOWN"
  | "EXTERNAL_SOURCE_FTP"
  | "EXTERNAL_SOURCE_POLLING"
  | "EXTERNAL_SOURCE_INGRID_API"
  | "EXTERNAL_SOURCE_CARRIER_API_PUSH"
  | "EXTERNAL_SOURCE_GENERATOR"
  | "EXTERNAL_SOURCE_INGRID_EXCEPTION";

export interface GetLogResponse {
  entries?: LogEntry[];
}

export interface GetTrackingEventsResponse {
  /** logistic_units is a list of logistic units connected to the TOS ID. */
  logistic_units?: LogisticUnit[];
  /** som_id is ID of the shipment associated with the order. */
  som_id?: string;
  /** tos_id is the order associated with the tracking event. */
  tos_id?: string;
  /** tracking_events are the tracking events related to the order itself (i.e ORDER_CREATED, ORDER_BOOKED) which belongs outside of the shipment tracking lifecycle. */
  tracking_events?: TrackingEvent[];
}

/** InstoreParcelArrived is sent from the `service-instore` when the parcel arrived to the location. */
export interface InstoreParcelArrived {
  /** PickupDeadline is the rfc3339 time when the parcel should be picked up by the customer. [optional] */
  pickup_deadline?: string;
  /** PickupLocationType is the type of the location where the parcel arrived. */
  pickup_location_type?: InstoreParcelArrivedPickupLocationType;
  /** ReceiveCode is the base64 string representing receive code needed to pick up a parcel from the store serviced by Ingrid Instore product. [optional] */
  receive_code?: string;
}

/**
 *  - SHELF: Parcel arrived to the shelf.
 *  - LOCKER: Parcel arrived to the locker.
 * @default "UNKNOWN"
 */
export type InstoreParcelArrivedPickupLocationType = "UNKNOWN" | "SHELF" | "LOCKER";

/**
 * InstoreParcelSentBack is sent from the `service-instore` when the parcel is sent back to the merchant.
 * This is only sent if the parcel was not picked up by the customer.
 */
export type InstoreParcelOverdue = object;

/** InstoreParcelPickedUp is sent from the `service-instore` when the parcel is picked up by the customer. */
export interface InstoreParcelPickedUp {
  /** NationalIdentificationNumberEncrypted is the SSN of the customer who picked up the parcel. */
  national_identification_number_encrypted?: string;
}

/** InstoreParcelRefused is sent from the `service-instore` when the parcel is refused by the customer. */
export interface InstoreParcelRefused {
  reason?: InstoreParcelRefusedReason;
}

/** @default "UNKNOWN" */
export type InstoreParcelRefusedReason =
  | "UNKNOWN"
  | "NO_REASON"
  | "NOT_ORDERED"
  | "GOODS_DAMAGED"
  | "PACKAGING_DAMAGED";

/** InstoreParcelRelocated is sent from the `service-instore` when the parcel is relocated by the store staff. */
export interface InstoreParcelRelocated {
  /** MovedTo is the location where the parcel was moved to. */
  moved_to?: InstoreParcelRelocatedMovedTo;
  /** ReceiveCode is the base64 string representing receive code needed to pick up a parcel from the new location in store serviced by Ingrid Instore product. [optional] */
  receive_code?: string;
}

/**
 *  - SHELF: Parcel was moved to the shelf.
 *  - LOCKER: Parcel was moved to the locker.
 * @default "UNKNOWN"
 */
export type InstoreParcelRelocatedMovedTo = "UNKNOWN" | "SHELF" | "LOCKER";

/** InstoreParcelReturned is sent from the `service-instore` in case of a passive return, requested by carrier (e.g. misrouted) */
export interface InstoreParcelReturned {
  /**
   * Location where the parcel was returned.
   * This field indicates the address or store where the parcel was physically returned by the customer.
   */
  location?: Address;
}

/** InstoreParcelSendAccepted is send when package is accepted in the Instore app in the Active Return scenario. */
export interface InstoreParcelSendAccepted {
  /**
   * Location where the parcel was returned.
   * This field indicates the address or store where the parcel was physically returned by the customer.
   */
  location?: Address;
}

export interface Item {
  /**
   * Attributes represents a collection of key-value pairs containing additional item properties.
   * Both keys and values are strings. Examples: {"brand": "Nike", "material": "cotton"}.
   */
  attributes?: Record<string, string>;
  /**
   * CancelledQuantity is the number of items that have been cancelled.
   * @format int32
   */
  cancelled_quantity?: number;
  /**
   * CancelledTotalPrice is the total price for all cancelled items of the same SKU in cents.
   * @format int32
   */
  cancelled_total_price?: number;
  /**
   * Discount is the discount for a given item in cents. Example: `20000` represents `200.00`.
   * @format int32
   */
  discount?: number;
  /** Image is the URL of the image of the given cart item. */
  image?: string;
  /** Name is the product name or title. */
  name?: string;
  /**
   * Price is the price of a single item with applied discounts in cents. Example: `20000` represents `200.00`.
   * @format int32
   */
  price?: number;
  /**
   * Quantity is the total number of a given non-cancelled product item in the cart.
   * @format int32
   */
  quantity?: number;
  /** SKU is a unique product identifier. */
  sku?: string;
  /**
   * TotalPrice is the total price for all non-cancelled items of the same SKU in cents
   * @format int32
   */
  total_price?: number;
  /** Properties that define item variant. */
  variant?: ItemVariant;
}

/** Properties that define item variant. */
export interface ItemVariant {
  color?: string;
  size?: string;
}

/** Location is a location where a tracking event occurred */
export interface Location {
  city?: string;
  country?: string;
  name?: string;
  postal_code?: string;
  region?: string;
}

export interface LogEntry {
  /** created_at is the rfc3339 time when the event occurred. Deprecated, use occurred_at. */
  created_at?: string;
  /** delivery_id is the delivery associated with the tracking event. */
  delivery_id?: string;
  /** Earliest and/or latest time the parcel is estimated to arrive to its destination. */
  estimated_time_of_arrival?: EstimatedTimeOfArrival;
  /** Earliest and/or latest time order items are estimated to be prepared by the merchant. */
  estimated_time_of_preparation?: EstimatedTimeOfPreparation;
  /** Earliest and/or latest time the parcel is estimated to be picked up by the carrier. */
  estimated_time_of_subission?: EstimatedTimeOfSubmission;
  /** id is the unique id identifying the log entry. */
  id?: string;
  /** Location is the location where the event took place. */
  location?: Location;
  /** occurred_at is the rfc3339 time when the event occurred. */
  occurred_at?: string;
  /** origin_status is a status code defined by the carrier or merchant. */
  origin_status?: string;
  /** origin_status_description is a human readable status description from the carrier. */
  origin_status_description?: string;
  /** received_at is the rfc3339 time when the event reached wimo event listener. */
  received_at?: string;
  /** site_id is the owner of the tracking event. */
  site_id?: string;
  /** status is status code defined by Ingrid (i.e Order received, Delivered, etc). Deprecated, use tracking_status. */
  status?: TrackingEventStatus;
  /** tos_id is the order associated with the tracking event. */
  tos_id?: string;
  /** tracking_number is the tracking number assigned by a carrier. */
  tracking_number?: string;
  /** Status code defined by Ingrid (i.e Order received, Delivered, etc). */
  tracking_status?: Status;
}

export interface LogisticUnit {
  /** carrier_product_id is an internal id for carrier products. */
  carrier_product_id?: string;
  /** carrier_product_ref is a carrier product reference from external system that is mapped in Ingrid and indicates where tracking URL should point to. */
  carrier_product_ref?: string;
  /** delivery_id is the delivery ID associated with the tracking event. */
  delivery_id?: string;
  /** DeliveryType is the registered type of delivery. */
  delivery_type?: DeliveryType;
  /** direction_type is a initial parcel direction. */
  direction_type?: DirectionType;
  /** Earliest and/or latest time when the parcel is estimated to arrive to its destination */
  estimated_time_of_arrival?: EstimatedTimeOfArrival;
  /** Earliest and/or latest time when the parcel is estimated to be picked up by the carrier. */
  estimated_time_of_submission?: EstimatedTimeOfSubmission;
  /** Name of the shipping method requested for the parcel booking. */
  requested_shipping_method?: string;
  /** shipping_method is the method by which the shipment is transported. */
  shipping_method?: string;
  /** tracking_events is a list of tracking events. */
  tracking_events?: TrackingEvent[];
  /** tracking_number is the tracking number assigned by a carrier. */
  tracking_number?: string;
  /** tracking_number_variants is the list of possible tracking number representation. */
  tracking_number_variants?: string[];
}

/**
 *  - SMS_CHANNEL: Ingrid internal SMS Channel.
 *  - EMAIL_CHANNEL: Ingrid internal email Channel.
 *  - CEP_CHANNEL: Customer Engagement Platform channel.
 *  - REVIEW_PLATFORM_CHANNEL: Review Platform channel.
 *  - INFOBIP_SMS_CHANNEL: Infobip provider SMS channel.
 *  - INFOBIP_EMAIL_CHANNEL: Infobip provider email channel.
 *  - API_NOTIFICATION_CHANNEL: API Notification channel.
 *  - KLAVIYO_CHANNEL: Klaviyo channel.
 *  - VOYADO_CHANNEL: Voyado channel.
 * @default "NOTIFICATION_CHANNEL_TYPE_UNKNOWN"
 */
export type NotificationChannelType =
  | "NOTIFICATION_CHANNEL_TYPE_UNKNOWN"
  | "SMS_CHANNEL"
  | "EMAIL_CHANNEL"
  | "CEP_CHANNEL"
  | "REVIEW_PLATFORM_CHANNEL"
  | "INFOBIP_SMS_CHANNEL"
  | "INFOBIP_EMAIL_CHANNEL"
  | "API_NOTIFICATION_CHANNEL"
  | "KLAVIYO_CHANNEL"
  | "VOYADO_CHANNEL";

export interface NotificationDelivered {
  summary?: NotificationSummary;
}

export interface NotificationFailed {
  summary?: NotificationSummary;
}

/** @default "UNKNOWN_KIND" */
export type NotificationKind =
  | "UNKNOWN_KIND"
  | "PROGRESS_KIND"
  | "PICKUP_REMINDER_KIND"
  | "ORDER_RECEIPT_KIND"
  | "ORDER_CANCELLED_BY_MERCHANT_KIND"
  | "ORDER_CANCELLED_BY_CUSTOMER_KIND"
  | "ORDER_ITEMS_CANCELLED_KIND"
  | "RETURN_RECEIPT_KIND"
  | "OUT_FOR_DELIVERY_KIND"
  | "DELIVERY_DELAYED_KIND"
  | "DELIVERY_FAILED_KIND"
  | "CENTRA_ORDER_CONFIRMED_KIND"
  | "SUBMISSION_DELAYED_KIND"
  | "PRICE_ADJUSTMENT_RECEIPT_KIND"
  | "RETURNED_IN_STORE_KIND"
  | "RETURNED_TO_WAREHOUSE_KIND"
  | "PARCEL_REFUSED_NO_REASON"
  | "PARCEL_REFUSED_NOT_WANTED"
  | "PARCEL_REFUSED_GOODS_DAMAGED"
  | "PARCEL_REFUSED_PACKAGING_DAMAGED"
  | "PARCEL_NOT_COLLECTED"
  | "PAYMENT_DECLINED_KIND"
  | "REMAINING_SHIPMENTS_CANCELLED_KIND"
  | "PAYMENT_DECLINED_FRAUD_CHECK_KIND"
  | "TRACKING_RULES_NOTIFICATION_KIND";

export interface NotificationSummary {
  /** Channel indicates the channel that the notification was sent to. */
  channel?: NotificationChannelType;
  /** ID is the unique ID of the notification. */
  id?: string;
  /** NotificationKind indicates the kind of notification the sending of which triggered the event. */
  kind?: NotificationKind;
  /** Recipient of the notification. It's a string because it can be an email or phone number, depending on the channel. */
  recipient?: string;
  recipient_type?: NotificationSummaryRecipientType;
  /** Step indicates the step that the notification was sent for. */
  step?: Step;
}

/** @default "UNKNOWN" */
export type NotificationSummaryRecipientType = "UNKNOWN" | "EMAIL" | "PHONE_NUMBER" | "API_ENDPOINT";

export interface NotificationTriggerred {
  summary?: NotificationSummary;
}

export interface OrderCancelled {
  cancelled_by?: OrderCancelledCancellingParty;
}

export type OrderCancelledByCustomer = object;

export type OrderCancelledByMerchant = object;

/** @default "UNKNOWN" */
export type OrderCancelledCancellingParty = "UNKNOWN" | "MERCHANT" | "CUSTOMER";

export interface OrderItemsCancelled {
  /** Cart represents the contents of a shopping cart. */
  cart?: Cart;
  delivery_groups?: OrderItemsCancelledDeliveryGroup[];
  is_all_items_processed?: boolean;
  items?: OrderItemsCancelledItem[];
  /** @format int64 */
  version?: string;
}

export interface OrderItemsCancelledDeliveryGroup {
  items?: Item[];
  tos_id?: string;
}

export interface OrderItemsCancelledItem {
  /** @format int32 */
  quantity?: number;
  sku?: string;
}

export interface OrderReceiptAvailable {
  /** Asset is a representation of a file that is stored in the service-tracking-assets`. */
  asset?: Asset;
}

export type OutForDelivery = object;

export interface PaymentDeclined {
  payment_provider?: string;
  reason?: PaymentDeclinedReason;
}

/** @default "UNKNOWN" */
export type PaymentDeclinedReason = "UNKNOWN" | "EXPIRED" | "FRAUD_CHECK";

/**
 * PickupReminderTriggered is sent when a reminder to pick up a parcel is triggered.
 * This could be used to notify the customer to pick up their parcel before a specified deadline.
 */
export interface PickupReminderTriggered {
  id?: string;
}

export interface PriceAdjustmentReceiptAvailable {
  /** Asset is a representation of a file that is stored in the service-tracking-assets`. */
  asset?: Asset;
}

/**
 * RemainingShipmentsCancelled is used in SplitShipment scenarios to
 * indicate that any shipments that have not been shipped will not be shipped at all.
 */
export type RemainingShipmentsCancelled = object;

export interface ReturnCreated {
  return_id?: string;
  /**
   *  - STORE: Return was registered in store.
   *  - WAREHOUSE: Return was sent to the warehouse.
   */
  type?: ReturnCreatedType;
}

/**
 *  - STORE: Return was registered in store.
 *  - WAREHOUSE: Return was sent to the warehouse.
 * @default "UNKNOWN"
 */
export type ReturnCreatedType = "UNKNOWN" | "STORE" | "WAREHOUSE";

export interface ReturnReceiptAvailable {
  /** Asset is a representation of a file that is stored in the service-tracking-assets`. */
  asset?: Asset;
}

/**
 * ReturnRequested is sent when a system or service wants to initiate the return process for a return parcel.
 * This message serves as a signal to indicate that the parcel should be visible in tracking systems.
 */
export interface ReturnRequested {
  /**
   * Instructions contains information needed for initiating the return process for a parcel.
   * This includes any necessary codes or details required by the system to facilitate the return.
   */
  instructions?: ReturnRequestedInstructions;
}

/**
 * Instructions contains information needed for initiating the return process for a parcel.
 * This includes any necessary codes or details required by the system to facilitate the return.
 */
export interface ReturnRequestedInstructions {
  return_code?: string;
}

/**
 *  - UNKNOWN: UNKNOWN indicates an unknown status which could not be harmonized.
 *  - ORDER_CREATED: ORDER_CREATED indicates that the order has been registered in Ingrid system.
 *  - ORDER_BOOKED: ORDER_BOOKED indicates that the order has been booked by the merchant.
 *  - PICKUP_BOOKING_SCHEDULED: PICKUP_BOOKING_SCHEDULED indicates that booking service will include the delivery in the next booking operation.
 *  - PICKUP_BOOKED: PICKUP_BOOKED indicates that the delivery has been successfully booked with the carrier.
 *  - IN_TRANSIT: IN_TRANSIT indicates that the delivery is under transportation to pickup point or in line haul.
 *  - DELIVERY_IN_PROGRESS: DELIVERY_IN_PROGRESS indicates that the delivery is on its way to a customers home address.
 *  - ARRIVED_AT_PICKUP_POINT: ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
 *  - DELIVERED: DELIVERED indicates that the delivery has been delivered to the customer.
 *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
 *  - DELAYED: DELAYED indicates that the delivery is delayed but will resume at a later time.
 *  - RETURNED: RETURNED indicates that the delivery has been returned.
 *  - INFO: INFO indicates some custom event.
 *  - ERROR: ERROR indicates that some error occurred.
 *  - SHIPMENT_CREATED: SHIPMENT_CREATED indicates that a shipment has been created in SOM.
 *  - LOGISTIC_UNIT_CREATED: LOGISTIC_UNIT_CREATED indicates that a logistic unit / (parcel-delivery) has been created in SOM.
 *  - LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER: LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER indicates that a logistic unit has received a tracking number.
 *  - NOTIFICATION_SENT: NOTIFICATION_SENT indicates that a delivery notification has been sent to the customer.
 *  - BOOKING_RECEIVED_BY_CARRIER: BOOKING_RECEIVED_BY_CARRIER indicates that the carrier has received booking information for the parcel.
 *  - FAILED: FAILED indicates that there was an attempt to deliver the package but it failed.
 *  - ARRIVED_AT_DISTRIBUTION_TERMINAL: ARRIVED_AT_DISTRIBUTION_TERMINAL indicates that the shipment has arrived to a distribution terminal and is waiting for final delivery
 *  - ON_HOLD: ON_HOLD indicates that the shipment is held up at the moment and some action is required.
 *  - RECEIVED_AT_PICKUP_POINT: RECEIVED_AT_PICKUP_POINT indicates that the package was put into a pickup locker.
 *  - DEPARTED_FROM_PICKUP_POINT: DEPARTED_FROM_PICKUP_POINT indicates that the package departed a pickup locker.
 *  - SHIPMENT_CANCELED: SHIPMENT_CANCELED indicates that a shipment has been canceled in SOM.
 *  - TRACKING_NUMBER_REGISTERED: TRACKING_NUMBER_REGISTERED indicates that the tracking number has been registered.
 *  - CUSTOM: CUSTOM indicates that event type was defined by external party.
 *  - LABEL_CREATED_BY_CARRIER: LABEL_CREATED_BY_CARRIER indicates that the label was created by carrier.
 *  - PICKUP_FAILED: PICKUP_FAILED indicates that the carrier failed to pickup the parcel.
 *  - RETURN_PICKUP_SCHEDULED: RETURN_PICKUP_SCHEDULED indicates that a return pickup has been booked.
 *  - CARRIER_PRODUCT_ID_ASSIGNED: CARRIER_PRODUCT_ID_ASSIGNED indicates that an internal carrier product ID was assigned to the tracking entity.
 *  - FORWARDED_TO_THIRD_PARTY: FORWARDED_TO_THIRD_PARTY indicates that the package was handed over to another third party for continuation of delivery.
 *  - IN_CUSTOMS: IN_CUSTOMS indicates that the package is undergoing customs clearance.
 *  - REDIRECTED: REDIRECTED indicates that package has been redirected from its original path.
 *  - LOST: LOST indicates that package has been lost and delivery cannot proceed.
 *  - DAMAGED: DAMAGED indicates that package has been damaged.
 *  - RETURNED_TO_SENDER: RETURNED_TO_SENDER indicates that package will be returned to the sender.
 *  - PICKUP_DELAYED: PICKUP_DELAYED means the carrier will try to pick up the shipment again
 * or that the sender has rescheduled the pick-up date for the shipment.
 *  - PICKED_UP: PICKED_UP indicates that the package was received from the point of origin.
 *  - UNDELIVERABLE: UNDELIVERABLE indicates that the package cannot be delivered.
 *  - CONTACT_MERCHANT_SUPPORT: CONTACT_MERCHANT_SUPPORT indicates that the consumer should contact merchant's customer support.
 *  - CONTACT_CARRIER_SUPPORT: CONTACT_CARRIER_SUPPORT indicates that the consumer should contact carrier's customer support.
 *  - DELIVERY_PROMISE_EXCEEDED: DELIVERY_PROMISE_EXCEEDED status is deprecated in favour of ESTIMATED_DELIVERY_TIME_EXCEEDED.
 *  - ESTIMATED_DELIVERY_TIME_EXCEEDED: ESTIMATED_DELIVERY_TIME_EXCEEDED indicates that the current ETA has been exceeded.
 *  - ESTIMATED_DELIVERY_TIME_UPDATED: ESTIMATED_DELIVERY_TIME_UPDATED indicates that ETA has been updated.
 *  - ESTIMATED_SUBMISSION_TIME_EXCEEDED: ESTIMATED_SUBMISSION_TIME_EXCEEDED indicates that the package pickup from point of origin is delayed.
 *  - ESTIMATED_SUBMISSION_TIME_UPDATED: ESTIMATED_SUBMISSION_TIME_UPDATED indicates that ETS has been updated.
 *  - ORDER_RECEIPT_AVAILABLE: ORDER_RECEIPT_AVAILABLE indicates that the order receipt is available for the consumer.
 *  - ORDER_CONFIRMED_BY_MERCHANT: ORDER_CONFIRMED_BY_MERCHANT indicates that the order has been confirmed by merchant.
 *
 * deprecated in favour of ORDER_CANCELLED
 *  - ORDER_CANCELLED_BY_MERCHANT: ORDER_CANCELLED_BY_MERCHANT indicates that the order has been cancelled by merchant.
 *
 * deprecated in favour of ORDER_CANCELLED
 *  - ORDER_CANCELLED_BY_CUSTOMER: ORDER_CANCELLED_BY_CUSTOMER indicates that the order has been cancelled by customer.
 *  - ORDER_ITEMS_CANCELLED: ORDER_ITEMS_CANCELLED indicates that the delivery does not contain all items from original order.
 *  - RETURN_RECEIPT_AVAILABLE: RETURN_RECEIPT_AVAILABLE indicates that the return receipt is available for the consumer.
 *  - PREPARED: PREPARED indicates that the order items have been prepared by the merchant.
 *  - SUBMITTED: SUBMITTED indicates that the order items have been submitteds to carrier.
 *  - AWAITING_SUPPLIER: AWAITING_SUPPLIER indicates that the merchant is awaiting item delivery from their supplier.
 *  - LINEHAUL_TO_CARRIER: LINEHAUL_TO_CARRIER indicates that ordered items are being transported to carrier.
 *  - ESTIMATED_PREPARATION_TIME_EXCEEDED: ESTIMATED_PREPARATION_TIME_EXCEEDED indicates that order items are taking longer than promised to prepare.
 *  - ESTIMATED_PREPARATION_TIME_UPDATED: ESTIMATED_PREPARATION_TIME_UPDATED indicates that the preparation promise for order items has been updated.
 *  - CENTRA_ORDER_CONFIRMED: CENTRA_ORDER_CONFIRMED indicates that the order has been confirmed in Centra platform.
 *  - INSTORE_ARRIVED_AT_PICKUP_POINT: `service-instore` specific statuses
 * INSTORE_ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
 *  - INSTORE_PARCEL_REFUSED: INSTORE_PARCEL_REFUSED indicates that the parcel has been refused by the customer.
 *  - INSTORE_PARCEL_PICKED_UP: INSTORE_PARCEL_PICKED_UP indicates that the parcel has been picked up by the customer.
 *  - INSTORE_PARCEL_OVERDUE: INSTORE_PARCEL_OVERDUE indicates that the parcel has not been picked up by the customer, and is overdue.
 *  - INSTORE_PARCEL_RETURNED: INSTORE_PARCEL_RETURNED indicates that the parcel has been returned by the customer.
 * It's indicates RETURN direction.
 *  - INSTORE_PARCEL_RELOCATED: INSTORE_PARCEL_RELOCATED indicates that the parcel has been relocated by store staff.
 *  - PRICE_ADJUSTMENT_RECEIPT_AVAILABLE: PRICE_ADJUSTMENT_RECEIPT_AVAILABLE indicates that the price adjustment receipt is available for the consumer.
 *  - NOTIFICATION_TRIGGERED: NOTIFICATION_TRIGGERED indicates that a tracking notification has been triggered in the Ingrid Tracking system.
 *  - NOTIFICATION_DELIVERED: NOTIFICATION_DELIVERED indicates that a delivery notification has been successfully delivered to the customer.
 *  - NOTIFICATION_FAILED: NOTIFICATION_FAILED indicates that a delivery notification has been failed to reach the customer.
 *  - ORDER_RETURNED_IN_STORE: ORDER_RETURNED_IN_STORE indicates that the order has been returned in merchant's store.
 *
 * deprecated in favour of ORDER_RETURNED
 *  - ORDER_RETURNED_TO_WAREHOUSE: ORDER_RETURNED_IN_STORE indicates that the order has been returned to the merchant's warehouse.
 *
 * deprecated in favour of ORDER_RETURNED
 *  - PAYMENT_DECLINED: PAYMENT_DECLINED indicates that we got PaymentDeclined exception.
 *  - NOT_COLLECTED_BY_CUSTOMER: NOT_COLLECTED_BY_CUSTOMER indicates that package/order was not collected in the pickup point.
 *  - REMAINING_SHIPMENTS_CANCELLED: REMAINING_SHIPMENTS_CANCELLED see RemainingShipmentsCancelled message comment.
 *  - CENTRA_DELIVERY_GROUP_CANCELLED: CENTRA_DELIVERY_GROUP_CANCELLED indicates that the delivery group has been cancelled in centra.
 *  - PICKUP_REMINDER_TRIGGERED: PICKUP_REMINDER_TRIGGERED  indicated that a reminder to pick up a parcel was triggered.
 *  - ORDER_RETURNED: ORDER_RETURNED indicates that the order has been returned.
 *  - ORDER_CANCELLED: ORDER_CANCELLED indicates that the order has been cancelled.
 *  - RETURN_REQUESTED: RETURN_REQUESTED indicates that the return process has been requested by the customer or merchant.
 * Strictly in the RETURN direction parcel.
 *  - INSTORE_PARCEL_SEND_ACCEPTED: INSTORE_PARCEL_SEND_ACCEPTED indicates that parcel was accepted in the store, but it does not belong to any order.
 *  - READY_FOR_PICKUP: READY_FOR_PICKUP indicates that a parcel is ready to be collected in the pickup location,
 * whether a carrier-managed location such as a locker or in a merchant-owned store.
 *  - PICKED_UP_BY_CUSTOMER: PICKED_UP_BY_CUSTOMER indicates that a parcel was picked up from the pickup location,
 * whether a carrier-managed location such as a locker or in a merchant-owned store.
 * @default "UNKNOWN"
 */
export type Status =
  | "UNKNOWN"
  | "ORDER_CREATED"
  | "ORDER_BOOKED"
  | "PICKUP_BOOKING_SCHEDULED"
  | "PICKUP_BOOKED"
  | "IN_TRANSIT"
  | "DELIVERY_IN_PROGRESS"
  | "ARRIVED_AT_PICKUP_POINT"
  | "DELIVERED"
  | "CANCELED"
  | "DELAYED"
  | "RETURNED"
  | "INFO"
  | "ERROR"
  | "SHIPMENT_CREATED"
  | "LOGISTIC_UNIT_CREATED"
  | "LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER"
  | "NOTIFICATION_SENT"
  | "BOOKING_RECEIVED_BY_CARRIER"
  | "FAILED"
  | "ARRIVED_AT_DISTRIBUTION_TERMINAL"
  | "ON_HOLD"
  | "RECEIVED_AT_PICKUP_POINT"
  | "DEPARTED_FROM_PICKUP_POINT"
  | "SHIPMENT_CANCELED"
  | "TRACKING_NUMBER_REGISTERED"
  | "CUSTOM"
  | "LABEL_CREATED_BY_CARRIER"
  | "PICKUP_FAILED"
  | "RETURN_PICKUP_SCHEDULED"
  | "CARRIER_PRODUCT_ID_ASSIGNED"
  | "FORWARDED_TO_THIRD_PARTY"
  | "IN_CUSTOMS"
  | "REDIRECTED"
  | "LOST"
  | "DAMAGED"
  | "RETURNED_TO_SENDER"
  | "PICKUP_DELAYED"
  | "PICKED_UP"
  | "UNDELIVERABLE"
  | "CONTACT_MERCHANT_SUPPORT"
  | "CONTACT_CARRIER_SUPPORT"
  | "DELIVERY_PROMISE_EXCEEDED"
  | "ESTIMATED_DELIVERY_TIME_EXCEEDED"
  | "ESTIMATED_DELIVERY_TIME_UPDATED"
  | "ESTIMATED_SUBMISSION_TIME_EXCEEDED"
  | "ESTIMATED_SUBMISSION_TIME_UPDATED"
  | "ORDER_RECEIPT_AVAILABLE"
  | "ORDER_CONFIRMED_BY_MERCHANT"
  | "ORDER_CANCELLED_BY_MERCHANT"
  | "ORDER_CANCELLED_BY_CUSTOMER"
  | "ORDER_ITEMS_CANCELLED"
  | "RETURN_RECEIPT_AVAILABLE"
  | "PREPARED"
  | "SUBMITTED"
  | "AWAITING_SUPPLIER"
  | "LINEHAUL_TO_CARRIER"
  | "ESTIMATED_PREPARATION_TIME_EXCEEDED"
  | "ESTIMATED_PREPARATION_TIME_UPDATED"
  | "CENTRA_ORDER_CONFIRMED"
  | "INSTORE_ARRIVED_AT_PICKUP_POINT"
  | "INSTORE_PARCEL_REFUSED"
  | "INSTORE_PARCEL_PICKED_UP"
  | "INSTORE_PARCEL_OVERDUE"
  | "INSTORE_PARCEL_RETURNED"
  | "INSTORE_PARCEL_RELOCATED"
  | "PRICE_ADJUSTMENT_RECEIPT_AVAILABLE"
  | "NOTIFICATION_TRIGGERED"
  | "NOTIFICATION_DELIVERED"
  | "NOTIFICATION_FAILED"
  | "ORDER_RETURNED_IN_STORE"
  | "ORDER_RETURNED_TO_WAREHOUSE"
  | "PAYMENT_DECLINED"
  | "NOT_COLLECTED_BY_CUSTOMER"
  | "REMAINING_SHIPMENTS_CANCELLED"
  | "CENTRA_DELIVERY_GROUP_CANCELLED"
  | "PICKUP_REMINDER_TRIGGERED"
  | "ORDER_RETURNED"
  | "ORDER_CANCELLED"
  | "RETURN_REQUESTED"
  | "INSTORE_PARCEL_SEND_ACCEPTED"
  | "READY_FOR_PICKUP"
  | "PICKED_UP_BY_CUSTOMER";

export interface StatusIdentifiers {
  /** MappingID is a specific mapping identifier for a given carrier, mandatory */
  mapping_id?: string;
  /** Product/Service code received from carrier, optional */
  product_code?: string;
  /** Additional reason code if applicable, optional */
  reason_code?: string;
  /** Main tracking status code received from carrier, mandatory */
  status_code?: string;
}

/** @default "STEP_UNKNOWN" */
export type Step =
  | "STEP_UNKNOWN"
  | "STEP_CONFIRMED_BY_MERCHANT"
  | "STEP_PREPARED_BY_MERCHANT"
  | "STEP_SUBMITTED_TO_CARRIER"
  | "STEP_ON_ROUTE"
  | "STEP_DELIVERED_TO_PICKUP_POINT"
  | "STEP_DELIVERED_TO_CONSUMER"
  | "STEP_TERMINATED"
  | "STEP_SENT_BACK"
  | "STEP_RETURN_REQUESTED"
  | "STEP_DELIVERED_TO_MERCHANT"
  | "STEP_AWAITING_SUPPLIER"
  | "STEP_LINEHAUL_TO_CARRIER";

export interface TrackingEvent {
  /** Asset is the asset associated with the event. */
  asset?: Asset;
  /** Cancelled items holds information about items that has been reported cancelled with this event. */
  cancelled_items?: OrderItemsCancelledItem[];
  /** carrier_product_id is an internal id for carrier products. */
  carrier_product_id?: string;
  /** carrier_product_ref is a carrier product reference from external system that is mapped in Ingrid and indicates where tracking URL should point to. */
  carrier_product_ref?: string;
  /**
   * ComputedStatus hold status that was computed from StatusIdentifiers
   *  - UNKNOWN: UNKNOWN indicates an unknown status which could not be harmonized.
   *  - ORDER_CREATED: ORDER_CREATED indicates that the order has been registered in Ingrid system.
   *  - ORDER_BOOKED: ORDER_BOOKED indicates that the order has been booked by the merchant.
   *  - PICKUP_BOOKING_SCHEDULED: PICKUP_BOOKING_SCHEDULED indicates that booking service will include the delivery in the next booking operation.
   *  - PICKUP_BOOKED: PICKUP_BOOKED indicates that the delivery has been successfully booked with the carrier.
   *  - IN_TRANSIT: IN_TRANSIT indicates that the delivery is under transportation to pickup point or in line haul.
   *  - DELIVERY_IN_PROGRESS: DELIVERY_IN_PROGRESS indicates that the delivery is on its way to a customers home address.
   *  - ARRIVED_AT_PICKUP_POINT: ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
   *  - DELIVERED: DELIVERED indicates that the delivery has been delivered to the customer.
   *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
   *  - DELAYED: DELAYED indicates that the delivery is delayed but will resume at a later time.
   *  - RETURNED: RETURNED indicates that the delivery has been returned.
   *  - INFO: INFO indicates some custom event.
   *  - ERROR: ERROR indicates that some error occurred.
   *  - SHIPMENT_CREATED: SHIPMENT_CREATED indicates that a shipment has been created in SOM.
   *  - LOGISTIC_UNIT_CREATED: LOGISTIC_UNIT_CREATED indicates that a logistic unit / (parcel-delivery) has been created in SOM.
   *  - LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER: LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER indicates that a logistic unit has received a tracking number.
   *  - NOTIFICATION_SENT: NOTIFICATION_SENT indicates that a delivery notification has been sent to the customer.
   *  - BOOKING_RECEIVED_BY_CARRIER: BOOKING_RECEIVED_BY_CARRIER indicates that the carrier has received booking information for the parcel.
   *  - FAILED: FAILED indicates that there was an attempt to deliver the package but it failed.
   *  - ARRIVED_AT_DISTRIBUTION_TERMINAL: ARRIVED_AT_DISTRIBUTION_TERMINAL indicates that the shipment has arrived to a distribution terminal and is waiting for final delivery
   *  - ON_HOLD: ON_HOLD indicates that the shipment is held up at the moment and some action is required.
   *  - RECEIVED_AT_PICKUP_POINT: RECEIVED_AT_PICKUP_POINT indicates that the package was put into a pickup locker.
   *  - DEPARTED_FROM_PICKUP_POINT: DEPARTED_FROM_PICKUP_POINT indicates that the package departed a pickup locker.
   *  - SHIPMENT_CANCELED: SHIPMENT_CANCELED indicates that a shipment has been canceled in SOM.
   *  - TRACKING_NUMBER_REGISTERED: TRACKING_NUMBER_REGISTERED indicates that the tracking number has been registered.
   *  - CUSTOM: CUSTOM indicates that event type was defined by external party.
   *  - LABEL_CREATED_BY_CARRIER: LABEL_CREATED_BY_CARRIER indicates that the label was created by carrier.
   *  - PICKUP_FAILED: PICKUP_FAILED indicates that the carrier failed to pickup the parcel.
   *  - RETURN_PICKUP_SCHEDULED: RETURN_PICKUP_SCHEDULED indicates that a return pickup has been booked.
   *  - CARRIER_PRODUCT_ID_ASSIGNED: CARRIER_PRODUCT_ID_ASSIGNED indicates that an internal carrier product ID was assigned to the tracking entity.
   *  - FORWARDED_TO_THIRD_PARTY: FORWARDED_TO_THIRD_PARTY indicates that the package was handed over to another third party for continuation of delivery.
   *  - IN_CUSTOMS: IN_CUSTOMS indicates that the package is undergoing customs clearance.
   *  - REDIRECTED: REDIRECTED indicates that package has been redirected from its original path.
   *  - LOST: LOST indicates that package has been lost and delivery cannot proceed.
   *  - DAMAGED: DAMAGED indicates that package has been damaged.
   *  - RETURNED_TO_SENDER: RETURNED_TO_SENDER indicates that package will be returned to the sender.
   *  - PICKUP_DELAYED: PICKUP_DELAYED means the carrier will try to pick up the shipment again
   * or that the sender has rescheduled the pick-up date for the shipment.
   *  - PICKED_UP: PICKED_UP indicates that the package was received from the point of origin.
   *  - UNDELIVERABLE: UNDELIVERABLE indicates that the package cannot be delivered.
   *  - CONTACT_MERCHANT_SUPPORT: CONTACT_MERCHANT_SUPPORT indicates that the consumer should contact merchant's customer support.
   *  - CONTACT_CARRIER_SUPPORT: CONTACT_CARRIER_SUPPORT indicates that the consumer should contact carrier's customer support.
   *  - DELIVERY_PROMISE_EXCEEDED: DELIVERY_PROMISE_EXCEEDED status is deprecated in favour of ESTIMATED_DELIVERY_TIME_EXCEEDED.
   *  - ESTIMATED_DELIVERY_TIME_EXCEEDED: ESTIMATED_DELIVERY_TIME_EXCEEDED indicates that the current ETA has been exceeded.
   *  - ESTIMATED_DELIVERY_TIME_UPDATED: ESTIMATED_DELIVERY_TIME_UPDATED indicates that ETA has been updated.
   *  - ESTIMATED_SUBMISSION_TIME_EXCEEDED: ESTIMATED_SUBMISSION_TIME_EXCEEDED indicates that the package pickup from point of origin is delayed.
   *  - ESTIMATED_SUBMISSION_TIME_UPDATED: ESTIMATED_SUBMISSION_TIME_UPDATED indicates that ETS has been updated.
   *  - ORDER_RECEIPT_AVAILABLE: ORDER_RECEIPT_AVAILABLE indicates that the order receipt is available for the consumer.
   *  - ORDER_CONFIRMED_BY_MERCHANT: ORDER_CONFIRMED_BY_MERCHANT indicates that the order has been confirmed by merchant.
   *
   * deprecated in favour of ORDER_CANCELLED
   *  - ORDER_CANCELLED_BY_MERCHANT: ORDER_CANCELLED_BY_MERCHANT indicates that the order has been cancelled by merchant.
   *
   * deprecated in favour of ORDER_CANCELLED
   *  - ORDER_CANCELLED_BY_CUSTOMER: ORDER_CANCELLED_BY_CUSTOMER indicates that the order has been cancelled by customer.
   *  - ORDER_ITEMS_CANCELLED: ORDER_ITEMS_CANCELLED indicates that the delivery does not contain all items from original order.
   *  - RETURN_RECEIPT_AVAILABLE: RETURN_RECEIPT_AVAILABLE indicates that the return receipt is available for the consumer.
   *  - PREPARED: PREPARED indicates that the order items have been prepared by the merchant.
   *  - SUBMITTED: SUBMITTED indicates that the order items have been submitteds to carrier.
   *  - AWAITING_SUPPLIER: AWAITING_SUPPLIER indicates that the merchant is awaiting item delivery from their supplier.
   *  - LINEHAUL_TO_CARRIER: LINEHAUL_TO_CARRIER indicates that ordered items are being transported to carrier.
   *  - ESTIMATED_PREPARATION_TIME_EXCEEDED: ESTIMATED_PREPARATION_TIME_EXCEEDED indicates that order items are taking longer than promised to prepare.
   *  - ESTIMATED_PREPARATION_TIME_UPDATED: ESTIMATED_PREPARATION_TIME_UPDATED indicates that the preparation promise for order items has been updated.
   *  - CENTRA_ORDER_CONFIRMED: CENTRA_ORDER_CONFIRMED indicates that the order has been confirmed in Centra platform.
   *  - INSTORE_ARRIVED_AT_PICKUP_POINT: `service-instore` specific statuses
   * INSTORE_ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
   *  - INSTORE_PARCEL_REFUSED: INSTORE_PARCEL_REFUSED indicates that the parcel has been refused by the customer.
   *  - INSTORE_PARCEL_PICKED_UP: INSTORE_PARCEL_PICKED_UP indicates that the parcel has been picked up by the customer.
   *  - INSTORE_PARCEL_OVERDUE: INSTORE_PARCEL_OVERDUE indicates that the parcel has not been picked up by the customer, and is overdue.
   *  - INSTORE_PARCEL_RETURNED: INSTORE_PARCEL_RETURNED indicates that the parcel has been returned by the customer.
   * It's indicates RETURN direction.
   *  - INSTORE_PARCEL_RELOCATED: INSTORE_PARCEL_RELOCATED indicates that the parcel has been relocated by store staff.
   *  - PRICE_ADJUSTMENT_RECEIPT_AVAILABLE: PRICE_ADJUSTMENT_RECEIPT_AVAILABLE indicates that the price adjustment receipt is available for the consumer.
   *  - NOTIFICATION_TRIGGERED: NOTIFICATION_TRIGGERED indicates that a tracking notification has been triggered in the Ingrid Tracking system.
   *  - NOTIFICATION_DELIVERED: NOTIFICATION_DELIVERED indicates that a delivery notification has been successfully delivered to the customer.
   *  - NOTIFICATION_FAILED: NOTIFICATION_FAILED indicates that a delivery notification has been failed to reach the customer.
   *  - ORDER_RETURNED_IN_STORE: ORDER_RETURNED_IN_STORE indicates that the order has been returned in merchant's store.
   *
   * deprecated in favour of ORDER_RETURNED
   *  - ORDER_RETURNED_TO_WAREHOUSE: ORDER_RETURNED_IN_STORE indicates that the order has been returned to the merchant's warehouse.
   *
   * deprecated in favour of ORDER_RETURNED
   *  - PAYMENT_DECLINED: PAYMENT_DECLINED indicates that we got PaymentDeclined exception.
   *  - NOT_COLLECTED_BY_CUSTOMER: NOT_COLLECTED_BY_CUSTOMER indicates that package/order was not collected in the pickup point.
   *  - REMAINING_SHIPMENTS_CANCELLED: REMAINING_SHIPMENTS_CANCELLED see RemainingShipmentsCancelled message comment.
   *  - CENTRA_DELIVERY_GROUP_CANCELLED: CENTRA_DELIVERY_GROUP_CANCELLED indicates that the delivery group has been cancelled in centra.
   *  - PICKUP_REMINDER_TRIGGERED: PICKUP_REMINDER_TRIGGERED  indicated that a reminder to pick up a parcel was triggered.
   *  - ORDER_RETURNED: ORDER_RETURNED indicates that the order has been returned.
   *  - ORDER_CANCELLED: ORDER_CANCELLED indicates that the order has been cancelled.
   *  - RETURN_REQUESTED: RETURN_REQUESTED indicates that the return process has been requested by the customer or merchant.
   * Strictly in the RETURN direction parcel.
   *  - INSTORE_PARCEL_SEND_ACCEPTED: INSTORE_PARCEL_SEND_ACCEPTED indicates that parcel was accepted in the store, but it does not belong to any order.
   *  - READY_FOR_PICKUP: READY_FOR_PICKUP indicates that a parcel is ready to be collected in the pickup location,
   * whether a carrier-managed location such as a locker or in a merchant-owned store.
   *  - PICKED_UP_BY_CUSTOMER: PICKED_UP_BY_CUSTOMER indicates that a parcel was picked up from the pickup location,
   * whether a carrier-managed location such as a locker or in a merchant-owned store.
   */
  computed_status?: Status;
  /** created_at is the RFC3339 nano formatted time when the event occurred. Deprecated, use occurred_at. */
  created_at?: string;
  /** custom_event_type_id is the identifier of the event defined by the external party. */
  custom_event_type_id?: string;
  /** Earliest and/or latest time when the parcel is estimated to arrive to its destination. */
  estimated_time_of_arrival?: EstimatedTimeOfArrival;
  /** Earliest and/or latest time when the parcel is estimated to be prepared by the merchant. */
  estimated_time_of_preparation?: EstimatedTimeOfPreparation;
  /** Earliest and/or latest time when the parcel is estimated to be picked up by the carrier. */
  estimated_time_of_submission?: EstimatedTimeOfSubmission;
  /** ULID defined for event by Ingrid. */
  event_id?: string;
  /** Exception hold information about exception and its payload. */
  exception?: Exception;
  /** external_source is an indicator of a type of tracking integration that is the origin of the event. */
  external_source?: ExternalSource;
  /** Location is the location where the event took place */
  location?: Location;
  /** occurred_at is the RFC3339 nano formatted time when the event occurred. */
  occurred_at?: string;
  /** origin_status is a status code defined by the carrier or merchant. */
  origin_status?: string;
  /** origin_status_description is a human readable status description from the carrier. */
  origin_status_description?: string;
  /** received_at is the RFC3339 time when the event was saved in wimo log. */
  received_at?: string;
  /** source is the name of the carrier or merchant from which the event originates from. */
  source?: string;
  /** status is status code defined by Ingrid (i.e Order received, Delivered, etc). Deprecated, use tracking_status. */
  status?: TrackingEventStatus;
  /** StatusIdentifiers holds information about the status identifiers. */
  status_identifiers?: StatusIdentifiers;
  /** Status code defined by Ingrid (i.e Order received, Delivered, etc). */
  tracking_status?: Status;
}

/**
 * Deprecated: wimo statuses are replaced with common.tracking.Status
 * - UNKNOWN: UNKNOWN indicates an unknown status which could not be harmonized.
 *  - ORDER_CREATED: ORDER_CREATED indicates that the order has been created by the merchant.
 *  - ORDER_BOOKED: ORDER_BOOKED indicates that the order has been booked by the merchant.
 *  - PICKUP_BOOKING_SCHEDULED: PICKUP_BOOKING_SCHEDULED indicates that booking service will include the delivery in the next booking operation.
 *  - PICKUP_BOOKED: PICKUP_BOOKED indicates that the delivery has been successfully booked with the carrier.
 *  - IN_TRANSIT: IN_TRANSIT indicates that the delivery is under transportation to pickup point or in line haul.
 *  - DELIVERY_IN_PROGRESS: DELIVERY_IN_PROGRESS indicates that the delivery is on its way to a customers home address.
 *  - ARRIVED_AT_PICKUP_POINT: ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
 *  - DELIVERED: DELIVERED indicates that the delivery has been delivered to the customer.
 *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
 *  - DELAYED: DELAYED indicates that the delivery will be delayed.
 *  - RETURNED: RETURNED indicates that the delivery has been returned.
 *  - INFO: INFO indicates some custom event.
 *  - ERROR: ERROR indicates that some error occurred.
 *  - SHIPMENT_CREATED: SHIPMENT_CREATED indicates that a shipment has been created in SOM.
 *  - LOGISTIC_UNIT_CREATED: LOGISTIC_UNIT_CREATED indicates that a logistic unit / (parcel-delivery) has been created in SOM.
 *  - LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER: LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER indicates that a logistic unit has received a tracking number.
 *  - NOTIFICATION_SENT: NOTIFICATION_SENT indicates that a delivery notification has been sent to the customer.
 *  - BOOKING_RECEIVED_BY_CARRIER: BOOKING_RECEIVED_BY_CARRIER indicates that the carrier has received booking information for the parcel.
 *  - FAILED: FAILED indicates that there was an attempt to deliver the package but it failed.
 * @default "UNKNOWN"
 */
export type TrackingEventStatus =
  | "UNKNOWN"
  | "ORDER_CREATED"
  | "ORDER_BOOKED"
  | "PICKUP_BOOKING_SCHEDULED"
  | "PICKUP_BOOKED"
  | "IN_TRANSIT"
  | "DELIVERY_IN_PROGRESS"
  | "ARRIVED_AT_PICKUP_POINT"
  | "DELIVERED"
  | "CANCELED"
  | "DELAYED"
  | "RETURNED"
  | "INFO"
  | "ERROR"
  | "SHIPMENT_CREATED"
  | "LOGISTIC_UNIT_CREATED"
  | "LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER"
  | "NOTIFICATION_SENT"
  | "BOOKING_RECEIVED_BY_CARRIER"
  | "FAILED";

export interface Error {
  /** @format int32 */
  code?: number;
  details?: Any[];
  message?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/v1/wimo" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title WIMO API
 * @version 1.0
 * @baseUrl /v1/wimo
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  trackingEvents = {
    /**
     * No description
     *
     * @name WimoGetTrackingEvents
     * @request GET:/tracking.events
     * @secure
     */
    wimoGetTrackingEvents: (
      query?: {
        tos_id?: string;
        tracking_number?: string;
        delivery_id?: string;
        /**
         * filter_status allows the caller to select what tracking event types should not be returned. Deprecated, use filter_tracking_status.
         *
         *  - UNKNOWN: UNKNOWN indicates an unknown status which could not be harmonized.
         *  - ORDER_CREATED: ORDER_CREATED indicates that the order has been created by the merchant.
         *  - ORDER_BOOKED: ORDER_BOOKED indicates that the order has been booked by the merchant.
         *  - PICKUP_BOOKING_SCHEDULED: PICKUP_BOOKING_SCHEDULED indicates that booking service will include the delivery in the next booking operation.
         *  - PICKUP_BOOKED: PICKUP_BOOKED indicates that the delivery has been successfully booked with the carrier.
         *  - IN_TRANSIT: IN_TRANSIT indicates that the delivery is under transportation to pickup point or in line haul.
         *  - DELIVERY_IN_PROGRESS: DELIVERY_IN_PROGRESS indicates that the delivery is on its way to a customers home address.
         *  - ARRIVED_AT_PICKUP_POINT: ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
         *  - DELIVERED: DELIVERED indicates that the delivery has been delivered to the customer.
         *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
         *  - DELAYED: DELAYED indicates that the delivery will be delayed.
         *  - RETURNED: RETURNED indicates that the delivery has been returned.
         *  - INFO: INFO indicates some custom event.
         *  - ERROR: ERROR indicates that some error occurred.
         *  - SHIPMENT_CREATED: SHIPMENT_CREATED indicates that a shipment has been created in SOM.
         *  - LOGISTIC_UNIT_CREATED: LOGISTIC_UNIT_CREATED indicates that a logistic unit / (parcel-delivery) has been created in SOM.
         *  - LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER: LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER indicates that a logistic unit has received a tracking number.
         *  - NOTIFICATION_SENT: NOTIFICATION_SENT indicates that a delivery notification has been sent to the customer.
         *  - BOOKING_RECEIVED_BY_CARRIER: BOOKING_RECEIVED_BY_CARRIER indicates that the carrier has received booking information for the parcel.
         *  - FAILED: FAILED indicates that there was an attempt to deliver the package but it failed.
         */
        filter_status?: (
          | "UNKNOWN"
          | "ORDER_CREATED"
          | "ORDER_BOOKED"
          | "PICKUP_BOOKING_SCHEDULED"
          | "PICKUP_BOOKED"
          | "IN_TRANSIT"
          | "DELIVERY_IN_PROGRESS"
          | "ARRIVED_AT_PICKUP_POINT"
          | "DELIVERED"
          | "CANCELED"
          | "DELAYED"
          | "RETURNED"
          | "INFO"
          | "ERROR"
          | "SHIPMENT_CREATED"
          | "LOGISTIC_UNIT_CREATED"
          | "LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER"
          | "NOTIFICATION_SENT"
          | "BOOKING_RECEIVED_BY_CARRIER"
          | "FAILED"
        )[];
        /**
         * filter_tracking_status allows the caller to select what tracking event types should not be returned.
         *
         *  - UNKNOWN: UNKNOWN indicates an unknown status which could not be harmonized.
         *  - ORDER_CREATED: ORDER_CREATED indicates that the order has been registered in Ingrid system.
         *  - ORDER_BOOKED: ORDER_BOOKED indicates that the order has been booked by the merchant.
         *  - PICKUP_BOOKING_SCHEDULED: PICKUP_BOOKING_SCHEDULED indicates that booking service will include the delivery in the next booking operation.
         *  - PICKUP_BOOKED: PICKUP_BOOKED indicates that the delivery has been successfully booked with the carrier.
         *  - IN_TRANSIT: IN_TRANSIT indicates that the delivery is under transportation to pickup point or in line haul.
         *  - DELIVERY_IN_PROGRESS: DELIVERY_IN_PROGRESS indicates that the delivery is on its way to a customers home address.
         *  - ARRIVED_AT_PICKUP_POINT: ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
         *  - DELIVERED: DELIVERED indicates that the delivery has been delivered to the customer.
         *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
         *  - DELAYED: DELAYED indicates that the delivery is delayed but will resume at a later time.
         *  - RETURNED: RETURNED indicates that the delivery has been returned.
         *  - INFO: INFO indicates some custom event.
         *  - ERROR: ERROR indicates that some error occurred.
         *  - SHIPMENT_CREATED: SHIPMENT_CREATED indicates that a shipment has been created in SOM.
         *  - LOGISTIC_UNIT_CREATED: LOGISTIC_UNIT_CREATED indicates that a logistic unit / (parcel-delivery) has been created in SOM.
         *  - LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER: LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER indicates that a logistic unit has received a tracking number.
         *  - NOTIFICATION_SENT: NOTIFICATION_SENT indicates that a delivery notification has been sent to the customer.
         *  - BOOKING_RECEIVED_BY_CARRIER: BOOKING_RECEIVED_BY_CARRIER indicates that the carrier has received booking information for the parcel.
         *  - FAILED: FAILED indicates that there was an attempt to deliver the package but it failed.
         *  - ARRIVED_AT_DISTRIBUTION_TERMINAL: ARRIVED_AT_DISTRIBUTION_TERMINAL indicates that the shipment has arrived to a distribution terminal and is waiting for final delivery
         *  - ON_HOLD: ON_HOLD indicates that the shipment is held up at the moment and some action is required.
         *  - RECEIVED_AT_PICKUP_POINT: RECEIVED_AT_PICKUP_POINT indicates that the package was put into a pickup locker.
         *  - DEPARTED_FROM_PICKUP_POINT: DEPARTED_FROM_PICKUP_POINT indicates that the package departed a pickup locker.
         *  - SHIPMENT_CANCELED: SHIPMENT_CANCELED indicates that a shipment has been canceled in SOM.
         *  - TRACKING_NUMBER_REGISTERED: TRACKING_NUMBER_REGISTERED indicates that the tracking number has been registered.
         *  - CUSTOM: CUSTOM indicates that event type was defined by external party.
         *  - LABEL_CREATED_BY_CARRIER: LABEL_CREATED_BY_CARRIER indicates that the label was created by carrier.
         *  - PICKUP_FAILED: PICKUP_FAILED indicates that the carrier failed to pickup the parcel.
         *  - RETURN_PICKUP_SCHEDULED: RETURN_PICKUP_SCHEDULED indicates that a return pickup has been booked.
         *  - CARRIER_PRODUCT_ID_ASSIGNED: CARRIER_PRODUCT_ID_ASSIGNED indicates that an internal carrier product ID was assigned to the tracking entity.
         *  - FORWARDED_TO_THIRD_PARTY: FORWARDED_TO_THIRD_PARTY indicates that the package was handed over to another third party for continuation of delivery.
         *  - IN_CUSTOMS: IN_CUSTOMS indicates that the package is undergoing customs clearance.
         *  - REDIRECTED: REDIRECTED indicates that package has been redirected from its original path.
         *  - LOST: LOST indicates that package has been lost and delivery cannot proceed.
         *  - DAMAGED: DAMAGED indicates that package has been damaged.
         *  - RETURNED_TO_SENDER: RETURNED_TO_SENDER indicates that package will be returned to the sender.
         *  - PICKUP_DELAYED: PICKUP_DELAYED means the carrier will try to pick up the shipment again
         * or that the sender has rescheduled the pick-up date for the shipment.
         *  - PICKED_UP: PICKED_UP indicates that the package was received from the point of origin.
         *  - UNDELIVERABLE: UNDELIVERABLE indicates that the package cannot be delivered.
         *  - CONTACT_MERCHANT_SUPPORT: CONTACT_MERCHANT_SUPPORT indicates that the consumer should contact merchant's customer support.
         *  - CONTACT_CARRIER_SUPPORT: CONTACT_CARRIER_SUPPORT indicates that the consumer should contact carrier's customer support.
         *  - DELIVERY_PROMISE_EXCEEDED: DELIVERY_PROMISE_EXCEEDED status is deprecated in favour of ESTIMATED_DELIVERY_TIME_EXCEEDED.
         *  - ESTIMATED_DELIVERY_TIME_EXCEEDED: ESTIMATED_DELIVERY_TIME_EXCEEDED indicates that the current ETA has been exceeded.
         *  - ESTIMATED_DELIVERY_TIME_UPDATED: ESTIMATED_DELIVERY_TIME_UPDATED indicates that ETA has been updated.
         *  - ESTIMATED_SUBMISSION_TIME_EXCEEDED: ESTIMATED_SUBMISSION_TIME_EXCEEDED indicates that the package pickup from point of origin is delayed.
         *  - ESTIMATED_SUBMISSION_TIME_UPDATED: ESTIMATED_SUBMISSION_TIME_UPDATED indicates that ETS has been updated.
         *  - ORDER_RECEIPT_AVAILABLE: ORDER_RECEIPT_AVAILABLE indicates that the order receipt is available for the consumer.
         *  - ORDER_CONFIRMED_BY_MERCHANT: ORDER_CONFIRMED_BY_MERCHANT indicates that the order has been confirmed by merchant.
         *
         * deprecated in favour of ORDER_CANCELLED
         *  - ORDER_CANCELLED_BY_MERCHANT: ORDER_CANCELLED_BY_MERCHANT indicates that the order has been cancelled by merchant.
         *
         * deprecated in favour of ORDER_CANCELLED
         *  - ORDER_CANCELLED_BY_CUSTOMER: ORDER_CANCELLED_BY_CUSTOMER indicates that the order has been cancelled by customer.
         *  - ORDER_ITEMS_CANCELLED: ORDER_ITEMS_CANCELLED indicates that the delivery does not contain all items from original order.
         *  - RETURN_RECEIPT_AVAILABLE: RETURN_RECEIPT_AVAILABLE indicates that the return receipt is available for the consumer.
         *  - PREPARED: PREPARED indicates that the order items have been prepared by the merchant.
         *  - SUBMITTED: SUBMITTED indicates that the order items have been submitteds to carrier.
         *  - AWAITING_SUPPLIER: AWAITING_SUPPLIER indicates that the merchant is awaiting item delivery from their supplier.
         *  - LINEHAUL_TO_CARRIER: LINEHAUL_TO_CARRIER indicates that ordered items are being transported to carrier.
         *  - ESTIMATED_PREPARATION_TIME_EXCEEDED: ESTIMATED_PREPARATION_TIME_EXCEEDED indicates that order items are taking longer than promised to prepare.
         *  - ESTIMATED_PREPARATION_TIME_UPDATED: ESTIMATED_PREPARATION_TIME_UPDATED indicates that the preparation promise for order items has been updated.
         *  - CENTRA_ORDER_CONFIRMED: CENTRA_ORDER_CONFIRMED indicates that the order has been confirmed in Centra platform.
         *  - INSTORE_ARRIVED_AT_PICKUP_POINT: `service-instore` specific statuses
         * INSTORE_ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
         *  - INSTORE_PARCEL_REFUSED: INSTORE_PARCEL_REFUSED indicates that the parcel has been refused by the customer.
         *  - INSTORE_PARCEL_PICKED_UP: INSTORE_PARCEL_PICKED_UP indicates that the parcel has been picked up by the customer.
         *  - INSTORE_PARCEL_OVERDUE: INSTORE_PARCEL_OVERDUE indicates that the parcel has not been picked up by the customer, and is overdue.
         *  - INSTORE_PARCEL_RETURNED: INSTORE_PARCEL_RETURNED indicates that the parcel has been returned by the customer.
         * It's indicates RETURN direction.
         *  - INSTORE_PARCEL_RELOCATED: INSTORE_PARCEL_RELOCATED indicates that the parcel has been relocated by store staff.
         *  - PRICE_ADJUSTMENT_RECEIPT_AVAILABLE: PRICE_ADJUSTMENT_RECEIPT_AVAILABLE indicates that the price adjustment receipt is available for the consumer.
         *  - NOTIFICATION_TRIGGERED: NOTIFICATION_TRIGGERED indicates that a tracking notification has been triggered in the Ingrid Tracking system.
         *  - NOTIFICATION_DELIVERED: NOTIFICATION_DELIVERED indicates that a delivery notification has been successfully delivered to the customer.
         *  - NOTIFICATION_FAILED: NOTIFICATION_FAILED indicates that a delivery notification has been failed to reach the customer.
         *  - ORDER_RETURNED_IN_STORE: ORDER_RETURNED_IN_STORE indicates that the order has been returned in merchant's store.
         *
         * deprecated in favour of ORDER_RETURNED
         *  - ORDER_RETURNED_TO_WAREHOUSE: ORDER_RETURNED_IN_STORE indicates that the order has been returned to the merchant's warehouse.
         *
         * deprecated in favour of ORDER_RETURNED
         *  - PAYMENT_DECLINED: PAYMENT_DECLINED indicates that we got PaymentDeclined exception.
         *  - NOT_COLLECTED_BY_CUSTOMER: NOT_COLLECTED_BY_CUSTOMER indicates that package/order was not collected in the pickup point.
         *  - REMAINING_SHIPMENTS_CANCELLED: REMAINING_SHIPMENTS_CANCELLED see RemainingShipmentsCancelled message comment.
         *  - CENTRA_DELIVERY_GROUP_CANCELLED: CENTRA_DELIVERY_GROUP_CANCELLED indicates that the delivery group has been cancelled in centra.
         *  - PICKUP_REMINDER_TRIGGERED: PICKUP_REMINDER_TRIGGERED  indicated that a reminder to pick up a parcel was triggered.
         *  - ORDER_RETURNED: ORDER_RETURNED indicates that the order has been returned.
         *  - ORDER_CANCELLED: ORDER_CANCELLED indicates that the order has been cancelled.
         *  - RETURN_REQUESTED: RETURN_REQUESTED indicates that the return process has been requested by the customer or merchant.
         * Strictly in the RETURN direction parcel.
         *  - INSTORE_PARCEL_SEND_ACCEPTED: INSTORE_PARCEL_SEND_ACCEPTED indicates that parcel was accepted in the store, but it does not belong to any order.
         *  - READY_FOR_PICKUP: READY_FOR_PICKUP indicates that a parcel is ready to be collected in the pickup location,
         * whether a carrier-managed location such as a locker or in a merchant-owned store.
         *  - PICKED_UP_BY_CUSTOMER: PICKED_UP_BY_CUSTOMER indicates that a parcel was picked up from the pickup location,
         * whether a carrier-managed location such as a locker or in a merchant-owned store.
         */
        filter_tracking_status?: (
          | "UNKNOWN"
          | "ORDER_CREATED"
          | "ORDER_BOOKED"
          | "PICKUP_BOOKING_SCHEDULED"
          | "PICKUP_BOOKED"
          | "IN_TRANSIT"
          | "DELIVERY_IN_PROGRESS"
          | "ARRIVED_AT_PICKUP_POINT"
          | "DELIVERED"
          | "CANCELED"
          | "DELAYED"
          | "RETURNED"
          | "INFO"
          | "ERROR"
          | "SHIPMENT_CREATED"
          | "LOGISTIC_UNIT_CREATED"
          | "LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER"
          | "NOTIFICATION_SENT"
          | "BOOKING_RECEIVED_BY_CARRIER"
          | "FAILED"
          | "ARRIVED_AT_DISTRIBUTION_TERMINAL"
          | "ON_HOLD"
          | "RECEIVED_AT_PICKUP_POINT"
          | "DEPARTED_FROM_PICKUP_POINT"
          | "SHIPMENT_CANCELED"
          | "TRACKING_NUMBER_REGISTERED"
          | "CUSTOM"
          | "LABEL_CREATED_BY_CARRIER"
          | "PICKUP_FAILED"
          | "RETURN_PICKUP_SCHEDULED"
          | "CARRIER_PRODUCT_ID_ASSIGNED"
          | "FORWARDED_TO_THIRD_PARTY"
          | "IN_CUSTOMS"
          | "REDIRECTED"
          | "LOST"
          | "DAMAGED"
          | "RETURNED_TO_SENDER"
          | "PICKUP_DELAYED"
          | "PICKED_UP"
          | "UNDELIVERABLE"
          | "CONTACT_MERCHANT_SUPPORT"
          | "CONTACT_CARRIER_SUPPORT"
          | "DELIVERY_PROMISE_EXCEEDED"
          | "ESTIMATED_DELIVERY_TIME_EXCEEDED"
          | "ESTIMATED_DELIVERY_TIME_UPDATED"
          | "ESTIMATED_SUBMISSION_TIME_EXCEEDED"
          | "ESTIMATED_SUBMISSION_TIME_UPDATED"
          | "ORDER_RECEIPT_AVAILABLE"
          | "ORDER_CONFIRMED_BY_MERCHANT"
          | "ORDER_CANCELLED_BY_MERCHANT"
          | "ORDER_CANCELLED_BY_CUSTOMER"
          | "ORDER_ITEMS_CANCELLED"
          | "RETURN_RECEIPT_AVAILABLE"
          | "PREPARED"
          | "SUBMITTED"
          | "AWAITING_SUPPLIER"
          | "LINEHAUL_TO_CARRIER"
          | "ESTIMATED_PREPARATION_TIME_EXCEEDED"
          | "ESTIMATED_PREPARATION_TIME_UPDATED"
          | "CENTRA_ORDER_CONFIRMED"
          | "INSTORE_ARRIVED_AT_PICKUP_POINT"
          | "INSTORE_PARCEL_REFUSED"
          | "INSTORE_PARCEL_PICKED_UP"
          | "INSTORE_PARCEL_OVERDUE"
          | "INSTORE_PARCEL_RETURNED"
          | "INSTORE_PARCEL_RELOCATED"
          | "PRICE_ADJUSTMENT_RECEIPT_AVAILABLE"
          | "NOTIFICATION_TRIGGERED"
          | "NOTIFICATION_DELIVERED"
          | "NOTIFICATION_FAILED"
          | "ORDER_RETURNED_IN_STORE"
          | "ORDER_RETURNED_TO_WAREHOUSE"
          | "PAYMENT_DECLINED"
          | "NOT_COLLECTED_BY_CUSTOMER"
          | "REMAINING_SHIPMENTS_CANCELLED"
          | "CENTRA_DELIVERY_GROUP_CANCELLED"
          | "PICKUP_REMINDER_TRIGGERED"
          | "ORDER_RETURNED"
          | "ORDER_CANCELLED"
          | "RETURN_REQUESTED"
          | "INSTORE_PARCEL_SEND_ACCEPTED"
          | "READY_FOR_PICKUP"
          | "PICKED_UP_BY_CUSTOMER"
        )[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetTrackingEventsResponse, Error>({
        path: `/tracking.events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  trackingLog = {
    /**
     * No description
     *
     * @name WimoGetLog
     * @request GET:/tracking.log
     * @secure
     */
    wimoGetLog: (
      query?: {
        /** entry_id is the id of the log entry which serves as a starting point for fetching entries. The next [limit] entries will be fetch not including the given entry id. If not set, the last [limit] items will be fetched. */
        entry_id?: string;
        /**
         * limit is the number of items that should be fetched. The default limit is 100.
         * @format int32
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetLogResponse, Error>({
        path: `/tracking.log`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
